<ng-container *ngIf="control">
    <div *ngIf="control.errors && control.touched"
    class="error-container {{classes}}">
        <p class="text-danger"
        style="margin: 0.25rem 0;"
        *ngFor="let err of getControlErrors()">• {{ err | translate}}</p>
    </div>
</ng-container>
